export const findPhotoCode = (photoCode, arr) => {
  return arr.find((item) => parseInt(item.photoCode) === parseInt(photoCode));
};

export const findMuatalItem = (arrX, arrY, sessionID) => {
  return arrX.filter((itemX) =>
    arrY.find(
      (itemY) =>
        itemY.photoCode === itemX.photoCodeUpload &&
        sessionID === itemY.sessionKey
    )
  );
};

export const findPosition = (arr, screen) =>
  arr.find((item) => item.state === parseInt(screen));

export const mapDataResolution = (arr, name) => {
  return arr.find((item) => item['preset'].name === name);
};
